<nb-card>
  <nb-card-body>
    <nb-tabset fullWidth (changeTab)="changeTab($event)">
      <nb-tab tabId="1" [tabTitle]="energyObjectivesTitle" [active]="defaultSelectedTab === 'energyObjectives'">
        @if (selectedTabId === 1) {
          <app-energy-carbon-objectives [objectiveType]="'energy'"></app-energy-carbon-objectives>
        }
      </nb-tab>
      <nb-tab tabId="2" [tabTitle]="carbonObjectivesTitle" [active]="defaultSelectedTab === 'carbonObjectives'">
        @if (selectedTabId === 2) {
          <app-energy-carbon-objectives [objectiveType]="'carbon'"></app-energy-carbon-objectives>
        }
      </nb-tab>
      <nb-tab tabId="3" [tabTitle]="emissionFactorsTitle" [active]="defaultSelectedTab === 'emissionFactors'">
        @if (selectedTabId === 3) {
          <app-emission-factors-details></app-emission-factors-details>
        }
      </nb-tab>
      <!--
      @if ((isFidji$ | async) === false) {
        <nb-tab tabId="4" [tabTitle]="energyPaybackTitle" [active]="defaultSelectedTab === 'energyPayback'">
          @if (selectedTabId === 4) {
            <div class="mt-5 ps-5">
              <div class="mb-4 section-title">{{ "Cash in" | translate }}</div>
              <app-cash-in-filters></app-cash-in-filters>
              <div class="mt-5 mb-4 section-title">{{ "Cash out" | translate }}</div>
              <app-cash-out-filters></app-cash-out-filters>
            </div>
          }
        </nb-tab>
      }
      -->
      <nb-tab tabId="5" [tabTitle]="epEfTitle" [active]="defaultSelectedTab === 'consumptionType'">
        @if (selectedTabId === 5) {
          <app-consumption-type-filter></app-consumption-type-filter>
        }
      </nb-tab>
      <!--
      @if ((isFidji$ | async) === false) {
      <nb-tab tabId="6" [tabTitle]="energyPriceTitle" [active]="defaultSelectedTab === 'energyPrice'">
        @if (selectedTabId === 6) {
          <app-inflation-hypothesis-details></app-inflation-hypothesis-details>
        }
      </nb-tab>
      }
      -->
    </nb-tabset>
  </nb-card-body>
</nb-card>
